<template>
	<ui-root v-if="loaded" :data="integrationSettings" :part="form" ref="frm" :errs="errors" :actions="dialogControls(env)"></ui-root>
</template>

<script setup lang="ts">
import {onMounted, onUnmounted, ref, watch, reactive} from "vue";
import {connectEventBus, injectEnv} from "@fd/Environment";
import type {IntegrationSettings} from "@t/setup/IntegrationSettings";
import type {WithMeta} from "@t/fd/WithMeta";
import {dialogControls, FormDefinition} from "@t/fd/layout/FormDefinition";
import type {ErrorMap} from "@fd/PartInjectKeys";
import {NetworkResponse} from "@fd/Types";
import {useRouter} from "vue-router";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import UiRoot from "@fd/containers/UiRoot.vue";
import {InterfaceRoot} from "@t/fd/InterfaceRoot.ts";
import {Pref} from "@t/setup/Pref.ts";

const env = injectEnv();
const navStore = useNavigationStore();
const router = useRouter();

const loaded = ref<boolean>(false);

const errors = reactive<ErrorMap>([]);
const integrationSettings = ref<IntegrationSettings|null>(null);
const form = ref<InterfaceRoot<FormDefinition>|null>(null);
const frm = ref(null);
const bus = connectEventBus("IntegrationSettingsPage");

function receivedData(data:Pref & WithMeta):void {
	if (data.META) {
		form.value = data.META.form;
		delete data.META;
	}
	integrationSettings.value = data;
	loaded.value = true;
	console.log("receive data:"+JSON.stringify(integrationSettings.value));
}

function loadData() {
	let endpoint = "api/integrationsettings?meta=true";
	return env.net.fetch(endpoint)
			.then((result) => result.json())
			.then(receivedData);
}

function saveData():Promise<NetworkResponse> {
	console.log("save data:"+JSON.stringify(integrationSettings.value));
    return env.net.fetch("api/integrationsettings", "PUT", integrationSettings.value);
}

bus.onCommand(["save", "saveAndBack"], async (cmd) => {
	errors.length = 0;
	const response = await saveData();
	if (response.ok) {
		if (cmd === "save") {
			const data = await response.json();
			receivedData(data);
			if (frm.value) {
				frm.value.setDirty(false);
			}
		} else {
			// Go back
			router.back();
		}
		return "ok";
	} else {
		const data = await response.json();
		if (Array.isArray(data?.problems)) {
			for (let problem of data.problems) {
				errors.push(problem);
			}
		}
		console.error(response);
		return "fail";
	}
});
navStore.defineMenu((mb) => mb.standardMenu());

onMounted(() => {
	loadData();
	navStore.forward(env.msg("menu.viewIntegrationSettings"));
});
</script>

<style>

</style>


